__turbopack_context__.v({
  "attendeesCount": "NotificationItem-module-scss-module__vUCSJa__attendeesCount",
  "authorInfo": "NotificationItem-module-scss-module__vUCSJa__authorInfo",
  "avatar": "NotificationItem-module-scss-module__vUCSJa__avatar",
  "avatarWrapper": "NotificationItem-module-scss-module__vUCSJa__avatarWrapper",
  "categoryBadge": "NotificationItem-module-scss-module__vUCSJa__categoryBadge",
  "hidden": "NotificationItem-module-scss-module__vUCSJa__hidden",
  "iconWrapper": "NotificationItem-module-scss-module__vUCSJa__iconWrapper",
  "notificationContent": "NotificationItem-module-scss-module__vUCSJa__notificationContent",
  "notificationDescription": "NotificationItem-module-scss-module__vUCSJa__notificationDescription",
  "notificationItem": "NotificationItem-module-scss-module__vUCSJa__notificationItem",
  "notificationTitle": "NotificationItem-module-scss-module__vUCSJa__notificationTitle",
  "textContent": "NotificationItem-module-scss-module__vUCSJa__textContent",
  "textSection": "NotificationItem-module-scss-module__vUCSJa__textSection",
  "unread": "NotificationItem-module-scss-module__vUCSJa__unread",
  "unreadDot": "NotificationItem-module-scss-module__vUCSJa__unreadDot",
});
